import React from "react";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import AddIcon from "@mui/icons-material/Add";

export default function AddBtn({ onClick, title }) {
  return (
    <Tooltip title={title}>
      <IconButton sx={{ color: "#2980d7" }} onClick={onClick}>
        <AddIcon />
      </IconButton>
    </Tooltip>
  );
}
